import {
  InputProvider,
  groupInput,
  input,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const SekoOmniParcelCarrierInput = groupInput({
  outboundProductionApiKey: input<string>({ validator: nonEmptyValidator }),
  returnsProductionApiKey: input<string>({ validator: nonEmptyValidator }),
  outboundTestApiKey: input<string>({ validator: nonEmptyValidator }),
  returnsTestApiKey: input<string>({ validator: nonEmptyValidator }),
});

export type SekoOmniParcelCarrierValue = InputProvider.Value<
  typeof SekoOmniParcelCarrierInput
>;

export type SekoOmniParcelCarrierForm = InputProvider.Form<
  typeof SekoOmniParcelCarrierInput
>;

export const sekoOmniParcelCarrierDefault = (): SekoOmniParcelCarrierValue => ({
  outboundProductionApiKey: "",
  returnsProductionApiKey: "",
  outboundTestApiKey: "",
  returnsTestApiKey: "",
});

export const CreateSekoOmniParcelCarrierForm = memo(
  function CreateSekoOmniParcelCarrierForm({
    carrierInput,
  }: {
    carrierInput: SekoOmniParcelCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="Outbound Production API Key"
          placeholder=""
          setValue={carrierInput.inputs.outboundProductionApiKey.setValue}
          value={carrierInput.inputs.outboundProductionApiKey.value}
        />
        <RedoTextInput
          label="Outbound Test API Key"
          placeholder=""
          setValue={carrierInput.inputs.outboundTestApiKey.setValue}
          value={carrierInput.inputs.outboundTestApiKey.value}
        />
        <RedoTextInput
          label="Returns Production API Key"
          placeholder=""
          setValue={carrierInput.inputs.returnsProductionApiKey.setValue}
          value={carrierInput.inputs.returnsProductionApiKey.value}
        />
        <RedoTextInput
          label="Returns Test API Key"
          placeholder=""
          setValue={carrierInput.inputs.returnsTestApiKey.setValue}
          value={carrierInput.inputs.returnsTestApiKey.value}
        />
      </>
    );
  },
);
